import Dialog from "../../atoms/dialog";
import { Button, Typography, Box } from "@material-ui/core";
import { useState, useEffect, Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import DeleteDelegate from "../delegates/DeleteDelegate";



const DeleteDelegateAlert = (props) => {
    const { onCompletion, element, id, onClose, setShowDeleteAlert } = props;


    const [open, setOpen] = useState(false)


    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return (

        <Dialog
            // title={"Delete"}
            open={true}
            handleClose={handleClose}
        >

            <DeleteDelegate element={element} onCompletion={onCompletion} setShowDeleteAlert={setShowDeleteAlert} id={id} onClose={onClose} />

        </Dialog >
    )

}

export default DeleteDelegateAlert;